import React from "react";

import LoggedOutHeader from "../LoggedInLayout/Header/LoggedOutHeader";

const LoggedOut = (props) => {
  return (
    <div>
      <LoggedOutHeader />
      <div className="sticky-top z-0 overflow-visible lg:overflow-hidden">
        {props.children}
      </div>
    </div>
  );
};

export default LoggedOut;
